module.exports = __webpack_public_path__ + "static/media/7VE.4a06efb5.gif";